module.exports = __webpack_public_path__ + "img/accounting-relation-setting.d53d2b41.svg";